import React, { Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Loader, { LoaderSuspense } from './utils/loader'
import { ToastContainer } from 'react-toastify'

import './assets/scss/style.scss'
import 'react-toastify/dist/ReactToastify.css'
import { useAuth } from './firebase/useAuth'
import AuthGuard from './guard/AuthGuard'
import { useMembership } from './firebase/useMembership'
import { useCms } from './firebase/useCms'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/auth/Login'))
const ForgotPassword = React.lazy(() => import('./views/pages/auth/ForgotPassword'))
const ChangePassword = React.lazy(() => import('./views/pages/auth/ChangePassword'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page403 = React.lazy(() => import('./views/pages/page403/Page403'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  const {pathname} = useLocation()
  const { autoLogin } = useAuth()
  const { loadProperties, syncNews, syncOptions } = useCms()
  const { syncAllCoupons } = useMembership()

  useEffect(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0
    })
  }, [pathname])

  useEffect(() => {
    loadProperties()
    const unSubOption = syncOptions()
    const unSubCoupons = syncAllCoupons()
    const unSubNews = syncNews()
    const unSubscribe = autoLogin()
    return () => {
      unSubCoupons()
      unSubscribe()
      unSubNews()
      unSubOption()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Suspense fallback={<LoaderSuspense />}>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/change" name="Change Password Page" element={<ChangePassword />} />
          <Route exact path="/forgot" name="Forgot Password Page" element={<ForgotPassword />} />
          {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
          <Route exact path="/403" name="Unauthorize 403" element={<Page403 />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route
            path="*"
            name="Home"
            element={
              <AuthGuard>
                <DefaultLayout />
              </AuthGuard>
            }
          />
        </Routes>
      </Suspense>
      <Loader />
      <ToastContainer />
    </>
  )
}

export default App
